import React from "react";
import config from "config";

import classNames from "../../OfferMaster/containers/index.scss";
import WebAppIframe from "../../../components/WebAppIframe";

export default function StoreCategoryReport() {
  return (
    <div style={{ width: "100%", height: "100%", margin: "0 auto" }}>
      <WebAppIframe
        src={`${
          config.casaWebAppUrl
        }/reports/store-category-report?cache-burst=${new Date().valueOf()}`}
        id="iframe"
        className={`${classNames.iframe}`}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/routes/LeadReport/StoreCategoryReport/StoreCategoryReport.js